import * as React from 'react';
import type { SVGProps } from 'react';
const SvgJpgGlyph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M2 8L3.82322 6.17678C3.92085 6.07915 4.07915 6.07915 4.17678 6.17678L6 8L6.82322 7.17678C6.92085 7.07915 7.07915 7.07915 7.17678 7.17678L9.75 9.75M2.5 10H9.5C9.77614 10 10 9.77614 10 9.5V2.5C10 2.22386 9.77614 2 9.5 2H2.5C2.22386 2 2 2.22386 2 2.5V9.5C2 9.77614 2.22386 10 2.5 10ZM7.625 4.5C7.625 4.77614 7.40114 5 7.125 5C6.84886 5 6.625 4.77614 6.625 4.5C6.625 4.22386 6.84886 4 7.125 4C7.40114 4 7.625 4.22386 7.625 4.5Z"
      stroke="#fff"
      strokeLinecap="round"
    />
  </svg>
);
export default SvgJpgGlyph;
